<template>
  <div class="">
    <main-map>
    </main-map>
    <points-map v-if="listRoute.length > 0" :positions="listRoute" />
    <div class="absolute top-0 right-0 w-full md:w-auto bg-white">
      <input type="file" @change="handleFileUpload" />
    </div>
    <pre-load-page v-if="preloadInfo" />
    <div class="absolute bottom-1 right-0 w-20 h-20 !opacity-60">
    <q-img  :src="logtype" alt="No Load" />
  </div>
  </div>
</template>

<script setup>
import {
  defineAsyncComponent, ref, onBeforeMount
} from 'vue';
import * as XLSX from 'xlsx';
import preloadImages from '@/components/preload-image';
import logtype from '@/assets/LOGOSIMBOLO-GEOVOY-PLATAFORMA.svg';

onBeforeMount(() => {
  preloadImages();
});


const MainMap = defineAsyncComponent(() => import('@/components/MainMap.vue'));
const PointsMap = defineAsyncComponent(() => import('@/components/PointsMap.vue'));
const PreLoadPage = defineAsyncComponent(() => import('@/components/PreLoadPage.vue'));
const addess = ref([]);
const listRoute = ref([]);
const preloadInfo = ref(false);
const apiKey = 'AIzaSyDFA5cg0aBPGo_PasRbBH_BkWdp9PmYLd8';
const mapApiJs = 'https://maps.googleapis.com/maps/api';

// const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const handleFileUpload = async (event) => {
  preloadInfo.value = true;
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    if (!file) {
      preloadInfo.value = false;
      return reject(new Error("No file selected"));
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const info = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Process headers and rows
        const headers = info[0].map(header => {
          if (header.toLowerCase() === 'compañía') return 'company';
          else if (header.toLowerCase() === 'empleado') return 'employee';
          else if (header.toLowerCase() === 'ubicación') return 'location';
          else if (header.toLowerCase() === 'turno') return 'shift';
          else if (header.toLowerCase() === 'dirección') return 'address';
          else if (header.toLowerCase() === 'colonia') return 'suburb';
          else if (header.toLowerCase() === 'ciudad') return 'city';
          else if (header.toLowerCase() === 'estado') return 'state';
          else if (header.toLowerCase() === 'cód post' || header.toLowerCase() === 'código postal') return 'cp';
        });
        info[0] = headers;
        const result = info.slice(1).map(row => {
          let obj = {};
          info[0].forEach((key, index) => {
            const value = row[index] !== null && row[index] !== undefined ? String(row[index]) : '';
            if (key === 'address') {
              const parts = value.split(' ');
              const lastPart = parts[parts.length - 1];

              // Check if the last part matches the pattern to remove
              if (/^\w-\w$|^N\/A$|^[A-Z]$/.test(lastPart)) obj[key] = parts.slice(0, -1).join(' ');
              else obj[key] = value;
            }
            else obj[key] = value;
          });
          return obj;
        });
        addess.value = result.map(data => `${data.address}, ${data.suburb}, ${data.city}, ${data.state}`.toLowerCase());

        for (const data of addess.value) {
          // console.log(data);
          try {
            const response = await fetch(`${mapApiJs}/geocode/json?address=${data}&key=${apiKey}`);
          if (response.ok) {
            const responseData = await response.json(); // Ensure you handle the response data
            listRoute.value.push({
              addess: responseData.results[0]?.formatted_address,
              location: responseData.results[0]?.geometry.location,
            });
          } else console.console.log(`Error address: ${data}`);
          } catch (error) {
            console.console.log(`Error address: ${data}`);
          }
          // await delay(200); // Add a 1-second delay between iterations
        }

        preloadInfo.value = false;
        resolve();
      } catch (error) {
        console.error("Error processing file:", error);
        preloadInfo.value = false;
        reject(error);
      }
    };

    reader.onerror = () => {
      preloadInfo.value = false;
      reject(new Error("File reading failed"));
    };

    reader.readAsArrayBuffer(file);
  });
};


</script>

<style scoped>
.tree-list {
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  width: 16rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-height: 100vh;
  overflow-y: auto;
}
</style>
